import ServiceManager from '../../service/ServiceManager';
import { data } from '../../constants/Constants';
import { getDevice } from './utilApi';
export function getCatalogo(TipoCatalogo,PerfilCodigo='') {
    const DispositivoId = getDevice();
    let params = {};
    params.url = `catalogo/ListarCatalogo?TipoCatalogo=${TipoCatalogo}&PerfilCodigo=${PerfilCodigo}`;
    return ServiceManager.prototype.Get(params);
}
export function setReclamo(CodigoDealer, CorreoElectronico, Alias, LocalId) {
    const DispositivoId = getDevice();
    let params = {};
    params.url = "dealer/ActualizaLocal";
    params.data = {
        'dto.CodigoDealer': CodigoDealer,
        'dto.DispositivoDealer': DispositivoId,
        'dto.CorreoElectronicoDealer': CorreoElectronico,
        'dto.Alias': Alias,
        'dto.LocalId': LocalId,
        'dto.Sistema': data.Sistema
    };
    return ServiceManager.prototype.Post(params);
}
export function setIncidente(CodigoDealer, CorreoElectronico, Comentario, IncidenteId) {
    const DispositivoId = getDevice();
    let params = {};
    params.url = "catalogo/GrabarIncidente";
    params.data = {
        'dto.CodigoDealer': CodigoDealer,
        'dto.DispositivoDealer': DispositivoId,
        'dto.CorreoElectronicoDealer': CorreoElectronico,
        'dto.Comentacio': Comentario,
        'dto.IncidenteId': IncidenteId,
        'dto.Sistema': data.Sistema
    };
    return ServiceManager.prototype.Post(params);
}
export function setRequerimiento(CodigoDealer, CorreoElectronico, Reclamo) {
    const DispositivoId = getDevice();
    let params = {};
    params.url = "catalogo/GrabarRequerimiento";
    params.data = {
        'dto.CodigoDealer': CodigoDealer,
        'dto.DispositivoDealer': DispositivoId,
        'dto.CorreoElectronicoDealer': CorreoElectronico,
        'dto.Reclamo': Reclamo,
        'dto.Sistema': data.Sistema
    };
    return ServiceManager.prototype.Post(params);
}